var chunkToChildrenMap = {
	"1322": [
		3686,
		2364,
		976,
		3535,
		3744,
		4227,
		7874,
		7367,
		6738,
		3519,
		337
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));